'use strict';

angular.module('atex.dam').controller('DamChangeStatusModalController', ['$scope', '$rootScope', '$q', 'ContentService',
	'DamService', '$translate', 'DamNotificationService', 'DamTemplateService', 'UIConfigurationService', 'DamQueryService', 'configuration',
	function ($scope, $rootScope, $q, ContentService, DamService, $translate,
						DamNotificationService, DamTemplateService, UIConfigurationService, DamQueryService, configuration) {
		$scope.objectName = '';
		$scope.loaded = false;
		$scope.showSpinner = true;
		$scope.article = atex.Content();
		var otherRelated = [];

		function getTemplate(objectType) {
			return UIConfigurationService.domainWidget(
				'widget-configurations',
				'onecms-widget-configurations',
				'changeStatusDlg',
				undefined).then(function (widget) {
				// First check for specific
				var templateId = atex.onecms.ObjectUtils.getByPath(widget, "specificTemplateId/" + objectType);
				if (!templateId) {
					templateId = atex.onecms.ObjectUtils.getByPath(widget, "defaultTemplateId") || "atex.dam.changeStatus";
				}
				return DamTemplateService.getTemplateById(templateId).then(function (_template) {
					if (!_template) {
						console.error("changeStatusDlg Template '" + templateId + "' NOT FOUND!");
						throw {
							"cause": "No template for changeStatusDlg " + templateId
						};
					}
					return _template;
				});
			});
		}

		function workOtherPages(pages) {
			var other = (pages || []).filter(function( obj ) {
				return obj.id !== $scope.article.id;
			});
			var promises = other.map(function (item) {
				return ContentService.getContent({id: item.id});
			});
			return $q.all(promises).then(function (contents) {
				otherRelated = contents;
			});
		}

		function updateOther() {
			if (!otherRelated || otherRelated.length === 0) {
				return $q.when();
			}
			if (($scope.article.template.multiPageCopyPaths || []).length === 0) {
				return $q.when();
			}

			$scope.article.template.multiPageCopyPaths.map(function (copyPath) {
				if (typeof copyPath === 'string') {
					var src = atex.onecms.ObjectUtils.accessor($scope.article, copyPath).value;
					if (src !== undefined) {
						otherRelated.forEach(function (other) {
							var dst = atex.onecms.ObjectUtils.accessor(other, copyPath).value;
							if (dst !== undefined) {
								atex.onecms.ObjectUtils.accessor(other, copyPath).value = src;
							}
						});
					}
				} else if (typeof copyPath === 'object') {
					if (copyPath.array && copyPath.key && copyPath.value) {
						var srcArray = atex.onecms.ObjectUtils.accessor($scope.article, copyPath.array).value;
						var value = _.find(srcArray || [], function(obj) {
							return obj[copyPath.key] === copyPath.value;
						});
						if (value !== undefined) {
							otherRelated.forEach(function (other) {
								var dstArray = atex.onecms.ObjectUtils.accessor(other, copyPath.array).value;
								if (!dstArray) {
									return;
								}
								var dstValue = _.find(dstArray, function(obj) {
									return obj[copyPath.key] === copyPath.value;
								});
								if (!dstValue) {
									if (dstArray) {
										dstArray.push(value);
									}
								} else {
									for(var k in value) {
										if (value.hasOwnProperty(k)) {
											dstValue[k] = value[k];
										}
									}
								}
							});
						}
					}
				}
			});
			var updatePromises = otherRelated.map(function (other) {
				other = atex.dam.AngularUtils.cleanUpJson(other, true);
				var transferInfo = {id: other.id, data: other.data, revision: other.revision};
				var json = angular.toJson(transferInfo);
				var cleanTransferInfo = angular.fromJson(json);
				return ContentService.updateContent(cleanTransferInfo);
			});
			return $q.all(updatePromises);
		}

		DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
			$scope.currentUserInfo = currentUserInfo;
			ContentService.getContent({id: $scope.ids[0]}).then(function (response) {
				$scope.article = angular.copy(response);
				var _type = atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/contentData/data/objectType");
				return getTemplate(_type).then(function (template) {
					$scope.template = angular.copy(template);
					$scope.article.template = $scope.template;
					var path = JSON.parse(JSON.stringify($scope.template.namePath || ["name"]));
					var pathArray = atex.onecms.ObjectUtils.expandShortPath(path);
					$scope.objectName = atex.onecms.ObjectUtils.getByPath(response.data.aspects, pathArray);
					return DamQueryService.checkForMultiPage($scope.article).then(function (pages) {
						// Pages from this results contains an array with id as an element, whereas $scope.ids is a list of ids
						// transform into required structure
						$scope.ids.forEach(function (i) {
							pages.push ({"id": i});
						});
						return workOtherPages(pages).then (function () {
							$scope.loaded = true;
							$scope.dirty = false;
						});
					});
				});
			}).catch(function (error) {
				$scope.showSpinner = false;
				var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
				DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
			});
		});

		$scope.hideSpinner = function () {
			$scope.showSpinner = false;
		};

		function callChangePrintPageStatus(contentId, statusId, comment, assignees) {
			return DamService.changePrintPageStatus(contentId, statusId, comment, assignees).then(function (resp) {
				var output = atex.onecms.ObjectUtils.getByPath(resp, 'data/output');
				if (output !== 'OK') {
					var _message = atex.onecms.ObjectUtils.getByPath(resp, 'data/message') || 'Error changing Page Status';
					DamNotificationService.addNotification(atex.dam.Notification({
						type: 'error',
						message: _message
					}), true);
				}
				return resp;
			}).then(undefined, function () {
				DamNotificationService.addNotification(atex.dam.Notification({
					type: 'error',
					message: 'Error changing Page Status'
				}), true);
			});
		}

		function changeOtherPrintPageStatus(statusId, comment, assignees) {
			if (!otherRelated || otherRelated.length === 0) {
				return $q.when([]);
			}
			var updatePromises = otherRelated.map(function (other) {
				return callChangePrintPageStatus(other.id, statusId, comment, assignees).then(function(resp) {
					var output = atex.onecms.ObjectUtils.getByPath(resp, 'data/output');
					if (output === 'OK') {
						return {id: other.id};
					}
				});
			});
			return $q.all(updatePromises);
		}

		function getAssigneesNames() {
			var dimensionsArray = atex.onecms.ObjectUtils.accessor($scope.article, 'data/aspects/atex.Metadata/data/metadata/dimensions').value;
			if (!dimensionsArray || dimensionsArray.length === 0) {
				return;
			}
			var sendToDim = _.find(dimensionsArray, function (dim) {
				return dim.id === 'dimension.sendto.Users';
			});
			if (!sendToDim || !sendToDim.entities) {
				return;
			}
			var array = [];
			sendToDim.entities.forEach(function (entity) {
				array.push(entity.name);
			});
			return array;
		}

		function changePrintPageStatus() {
			var statusId = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/atex.WFContentStatus/data/status/statusID');
			var comment = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/atex.WFContentStatus/data/comment');
			var assignees = getAssigneesNames();
			assignees = assignees !== undefined ? assignees.join(';') : undefined;
			return callChangePrintPageStatus($scope.article.id, statusId, comment, assignees).then(function (resp) {
				var output = atex.onecms.ObjectUtils.getByPath(resp, 'data/output');
				if (output === 'OK') {
					return changeOtherPrintPageStatus(statusId, comment, assignees).then(function (updates) {
						updates = updates.filter(function(element) {
							return element !== undefined;
						});
						updates.unshift({id: $scope.article.id});
						var status = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/atex.WFContentStatus/data/status');
						$scope.doOk(updates, status);
					});
				}
			}).finally(function () {
				$scope.showSpinner = false;
			});
		}

		function isChangingPrintPageStatus() {
			var objectType = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/contentData/data/objectType');
			var docId = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/atex.print.Page/data/docId');
			return objectType === 'page' && docId > 0;
		}

		$scope.doSave = function () {
			$scope.showSpinner = true;
			if (configuration.getUseChangePrintPageStatus()) {
				if (isChangingPrintPageStatus()) {
					return changePrintPageStatus();
				}
			}

			var transferInfo = {id: $scope.article.id, data: $scope.article.data, revision: $scope.article.revision};
			var json = angular.toJson(transferInfo);
			var cleanTransferInfo = angular.fromJson(json);
			ContentService.updateContent(cleanTransferInfo).then(function (update) {
				var _templ = $scope.article.template; // preserve template
				$scope.article = update;
				$scope.article.template = _templ; // update local scope article with resp from db
				updateOther().then(function(updates) {
					$scope.showSpinner = false;
					updates = updates || [];
					updates.unshift(update);
					$scope.doOk(updates);
				});
			}).then(null, function (error) {
				var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
				DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
				$scope.showSpinner = false;
			});
		};

		$scope.changeEndCallback = function (data) {
			$scope.article.data = data;
			$scope.dirty = true;
			$scope.$digest();
		};

		$scope.initCallback = function () {
		};

		$scope.changeStartCallback = function () {
		};

		$scope.isOkEnabled = function () {
			return !$scope.showSpinner && $scope.dirty;
		};
	}
]);
